<template>
  <div>
    <v-card class="elevation-12">
      <v-toolbar dark color="primary">
        <v-icon>phonelink_setup</v-icon>
        <v-toolbar-title>Sincronizar con Telegram</v-toolbar-title>
      </v-toolbar>
      <v-alert v-if="notfound" :value="true" type="error" color="red">
        Perfil no encontrado.
      </v-alert>
      <v-card-text v-if="loading">
        Cargando...
        <v-progress-linear
          indeterminate
          color="blue"
          class="mb-0"
        ></v-progress-linear>
      </v-card-text>
      <v-card-text v-if="!isTelegramSyncronized && !loading && !notfound">
        No tienes ningún perfil de Telegram asociado.
        <br />
        <br />
        Pulsa el botón a continuación para vincular tu cuenta.
        <br />
        <!-- Callback mode -->
        <vue-telegram-login
          mode="callback"
          telegram-login="NotificameSistemaBot"
          requestAccess="read"
          @callback="callbackTelegram"
        />
        No olvides permitir que el bot te pueda mandar mensajes y no lo bloquees en Telegram.
      </v-card-text>
      <v-card-text v-if="isTelegramSyncronized && !loading && !notfound">
        Tienes una cuenta de Telegram vinculada.
        <br />
        No bloquees el bot para que así te pueda mandar mensajes.
        <v-flex xs12 md5>
          <v-btn
            outline
            color="red darken-1"
            dark
            block
            @click="unsyncTelegram"
          >
            <v-icon left>
              phonelink_erase
            </v-icon>
            Desvincular cuenta
          </v-btn>
        </v-flex>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { vueTelegramLogin } from "vue-telegram-login";
import firebase from "firebase";

let firebaseApp;
if (!firebase.apps.length) {
  firebaseApp = firebase.initializeApp({
    apiKey: "AIzaSyBnuZJIuRvweJ_qX4ZEmQCe2cerF92RCz4",
    authDomain: "tfgr-9ed26.firebaseapp.com",
    databaseURL: "https://tfgr-9ed26.firebaseio.com",
    projectId: "tfgr-9ed26",
    storageBucket: "tfgr-9ed26.appspot.com",
    messagingSenderId: "47742064305"
  });
} else {
  firebaseApp = firebase.app();
}
export const db = firebaseApp.database();

//Menú para sincronizar la cuenta con Telegram
// @group Configurar usuario
export default {
  name: "SyncTelegram",
  components: { vueTelegramLogin },
  data() {
    return {
      loading: true,
      notfound: false
    };
  },
  methods: {
    // @vuese
    // Extrae la información de la cuenta de Telegram y la asocia al usuario
    // @arg Cuenta de Telegram e ID del usuario
    callbackTelegram(user) {
      // gets user as an input
      // id, first_name, last_name, username,
      // photo_url, auth_date and hash
      this.$store.dispatch("syncTelegram", {
        id: user.id,
        uid: this.$store.state.user.uid
      });
    },
    // @vuese
    // Extrae el ID del usuario
    getUid() {
      return this.$store.state.user.uid;
    },
    // @vuese
    // Desvincula la cuenta de Telegramd del usuario
    // @arg ID del usuario
    unsyncTelegram() {
      if (
        confirm(
          "¿Estás seguro de que quieres desvincular tu cuenta de Telegram?\nNo podrás recibir ninguna notificación por Telegram."
        )
      ) {
        this.$store.dispatch("unsyncTelegram", {
          uid: this.$store.state.user.uid
        });
      }
    }
  },
  created() {
    this.$bindAsArray(
      "arrayPerfilTelegram",
      db
        .ref("users")
        .orderByChild("uid")
        .equalTo(this.getUid())
        .limitToFirst(1),
      snap => {
        if (this.arrayPerfilTelegram.length === 0) {
          this.notfound = true;
        }
        this.loading = false;
      },
      error => {
        if (this.arrayPerfilTelegram.length === 0) {
          this.notfound = true;
        }
        this.loading = false;
      }
    );
  },
  computed: {
    // @vuese
    // Devuelve false si no encuentra resultados o el ID de Telegram es nulo
    isTelegramSyncronized() {
      return !(
        this.arrayPerfilTelegram[0] === null ||
        this.arrayPerfilTelegram[0] === undefined ||
        this.arrayPerfilTelegram[0].telegramID === null ||
        this.arrayPerfilTelegram[0].telegramID === undefined
      );
    }
  }
};
</script>
